import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`You can view my Resume if you click `}<a parentName="p" {...{
        "href": "https://aditya-kumawat-resume.netlify.app"
      }}>{`THIS.`}</a>{`
You can always send me a mail on `}<a parentName="p" {...{
        "href": "mailto:aditya.kumawat63@gmail.com"
      }}>{`aditya.kumawat63@gmail.com`}</a>{`
Find me on any one of these platforms: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/aditya-kumawat"
      }}>{`LinkedIn`}</a>{` | `}<a parentName="p" {...{
        "href": "https://www.facebook.com/aditya.kumawat.127/"
      }}>{`Facebook`}</a>{` | `}<a parentName="p" {...{
        "href": "%22https://www.instagram.com/adithinksinstaisshit/%22"
      }}>{`Instagram`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      